import React from "react";
import clsx from "clsx";
import { useIntl } from "react-intl";

import styles from "./status-toggle-label.module.scss";

interface IStatusToggleLabelProps {
  active: boolean;
  disabled?: boolean;
  onClick: () => void;
  title: string;
}

/**
 * Active/Inactive status label that doubles as the platform on/off toggle. Same green/red palette
 * as `LabelComponent`, but with the square-ish corners of the sync button (it's a clickable button).
 */
const StatusToggleLabel = ({ active, disabled, onClick, title }: IStatusToggleLabelProps): JSX.Element => {
  const intl = useIntl();

  return (
    <button
      type="button"
      className={clsx(styles.label, active ? styles.active : styles.inactive)}
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      {intl.formatMessage({
        id: active ? "productPageSync.platform.active" : "productPageSync.platform.inactive"
      })}
    </button>
  );
};

export { StatusToggleLabel };
